export const PAGE_CONFIG = {
  personal: {
    path: '/personalAdd',
    type: 'personal',
  },
  enterprise: {
    path: '/enterpriseAdd',
    type: 'enterprise',
  },
}
